const defineds = {};

defineds.getDefinedLabel = (arr, value) => {
    if (arr && value) {
        const result = arr.find((item) => {
            return item.value === value;
        });

        return result?.label || value;
    }
    return "";
};

defineds.getDefinedLabels = (dataArr, valueArr) => {
    if (!dataArr || dataArr.length === 0 || !valueArr || valueArr.length === 0) {
        return "";
    }
    const fl = dataArr.filter((o) => valueArr.includes(o.value));
    return fl.map((o) => o.label).join(",");
};

defineds.getDefinedValue = (arr, label) => {
    if (arr && label) {
        const result = arr.find((item) => {
            return item.label === label;
        });
        return result.value;
    }
    return "";
};

defineds.getChild = (arr, value) => {
    const f = arr.filter((o) => o.value === value);
    if (!f || f.length === 0) {
        return [];
    }
    return f[0].child;
};

defineds.COUNTRY_PHONE = [
    { value: "KR", label: "82" },
    { value: "AF", label: "93" },
    { value: "AL", label: "335" },
    { value: "DZ", label: "213" },
    { value: "AS", label: "684" },
    { value: "AD", label: "376" },
    { value: "AO", label: "244" },
    { value: "AG", label: "1-809" },
    { value: "AR", label: "54" },
    { value: "AM", label: "374" },
    { value: "AW", label: "297" },
    { value: "AU", label: "61" },
    { value: "AT", label: "43" },
    { value: "AZ", label: "994" },
    { value: "BS", label: "1-242" },
    { value: "BH", label: "973" },
    { value: "BD", label: "880" },
    { value: "BB", label: "1-246" },
    { value: "BY", label: "375" },
    { value: "BE", label: "32" },
    { value: "BZ", label: "501" },
    { value: "BJ", label: "229" },
    { value: "BM", label: "1-441" },
    { value: "BT", label: "975" },
    { value: "BO", label: "591" },
    { value: "BA", label: "387" },
    { value: "BW", label: "267" },
    { value: "BR", label: "55" },
    { value: "BN", label: "673" },
    { value: "BG", label: "359" },
    { value: "BF", label: "226" },
    { value: "BI", label: "257" },
    { value: "KH", label: "855" },
    { value: "CM", label: "237" },
    { value: "CA", label: "1" },
    { value: "CV", label: "238" },
    { value: "KY", label: "1" },
    { value: "CF", label: "236" },
    { value: "TD", label: "235" },
    { value: "GG", label: "56" },
    { value: "CL", label: "56" },
    { value: "CN", label: "86" },
    { value: "CO", label: "57" },
    { value: "KM", label: "269" },
    { value: "CG", label: "242" },
    { value: "CD", label: "242" },
    { value: "CR", label: "506" },
    { value: "CI", label: "225" },
    { value: "HR", label: "385" },
    { value: "CU", label: "53" },
    { value: "CW", label: "420" },
    { value: "CY", label: "357" },
    { value: "CZ", label: "420" },
    { value: "DK", label: "45" },
    { value: "DJ", label: "253" },
    { value: "DM", label: "1-767" },
    { value: "DO", label: "1-767" },
    { value: "EC", label: "593" },
    { value: "EG", label: "20" },
    { value: "SV", label: "503" },
    { value: "GQ", label: "240" },
    { value: "ER", label: "291" },
    { value: "EE", label: "372" },
    { value: "ET", label: "251" },
    { value: "FO", label: "298" },
    { value: "FJ", label: "679" },
    { value: "FI", label: "358" },
    { value: "FR", label: "33" },
    { value: "PF", label: "689" },
    { value: "GA", label: "241" },
    { value: "GM", label: "220" },
    { value: "GE", label: "995" },
    { value: "DE", label: "49" },
    { value: "GH", label: "233" },
    { value: "GI", label: "350" },
    { value: "GR", label: "30" },
    { value: "GL", label: "299" },
    { value: "GD", label: "1-809" },
    { value: "GU", label: "1" },
    { value: "GT", label: "502" },
    { value: "GN", label: "224" },
    { value: "GW", label: "245" },
    { value: "GY", label: "592" },
    { value: "HT", label: "509" },
    { value: "HN", label: "504" },
    { value: "HK", label: "852" },
    { value: "HU", label: "36" },
    { value: "IS", label: "354" },
    { value: "IN", label: "91" },
    { value: "ID", label: "62" },
    { value: "IR", label: "98" },
    { value: "IQ", label: "964" },
    { value: "IE", label: "353" },
    { value: "IM", label: "" },
    { value: "IL", label: "972" },
    { value: "IT", label: "39" },
    { value: "JM", label: "1-876" },
    { value: "JP", label: "81" },
    { value: "JO", label: "962" },
    { value: "KZ", label: "7" },
    { value: "KE", label: "254" },
    { value: "KI", label: "686" },
    { value: "KS", label: "856" },
    { value: "KW", label: "965" },
    { value: "KG", label: "7" },
    { value: "LA", label: "856" },
    { value: "LV", label: "371" },
    { value: "LB", label: "961" },
    { value: "LS", label: "266" },
    { value: "LR", label: "231" },
    { value: "LY", label: "218" },
    { value: "LI", label: "41-75" },
    { value: "LT", label: "370" },
    { value: "LU", label: "362" },
    { value: "MO", label: "853" },
    { value: "MK", label: "389" },
    { value: "MG", label: "261" },
    { value: "MW", label: "265" },
    { value: "MY", label: "60" },
    { value: "MV", label: "960" },
    { value: "ML", label: "223" },
    { value: "MT", label: "356" },
    { value: "MH", label: "692" },
    { value: "MR", label: "222" },
    { value: "MU", label: "230" },
    { value: "YT", label: "269-6" },
    { value: "MX", label: "52" },
    { value: "FM", label: "691" },
    { value: "MD", label: "373" },
    { value: "MC", label: "377" },
    { value: "MN", label: "976" },
    { value: "ME", label: "381" },
    { value: "MA", label: "212" },
    { value: "MZ", label: "258" },
    { value: "MM", label: "95" },
    { value: "NA", label: "264" },
    { value: "NP", label: "977" },
    { value: "NL", label: "31" },
    { value: "NC", label: "687" },
    { value: "NZ", label: "64" },
    { value: "NI", label: "505" },
    { value: "NE", label: "227" },
    { value: "NG", label: "234" },
    { value: "MP", label: "1-670" },
    { value: "NO", label: "47" },
    { value: "OM", label: "968" },
    { value: "PK", label: "92" },
    { value: "PW", label: "680" },
    { value: "PA", label: "507" },
    { value: "PG", label: "675" },
    { value: "PY", label: "595" },
    { value: "PE", label: "51" },
    { value: "PH", label: "63" },
    { value: "PL", label: "48" },
    { value: "PT", label: "351" },
    { value: "PR", label: "1-787" },
    { value: "QA", label: "974" },
    { value: "RO", label: "40" },
    { value: "RU", label: "7" },
    { value: "RW", label: "250" },
    { value: "WS", label: "685" },
    { value: "SM", label: "378" },
    { value: "ST", label: "239" },
    { value: "SA", label: "966" },
    { value: "SN", label: "221" },
    { value: "RS", label: "381" },
    { value: "SC", label: "248" },
    { value: "SL", label: "232" },
    { value: "SG", label: "65" },
    { value: "SX", label: "252" },
    { value: "SK", label: "421" },
    { value: "SI", label: "386" },
    { value: "SB", label: "677" },
    { value: "SO", label: "252" },
    { value: "ZA", label: "27" },
    { value: "SS", label: "268" },
    { value: "ES", label: "34" },
    { value: "LK", label: "94" },
    { value: "KN", label: "963" },
    { value: "LC", label: "7" },
    { value: "MF", label: "255" },
    { value: "VC", label: "66" },
    { value: "SD", label: "249" },
    { value: "SR", label: "597" },
    { value: "SZ", label: "268" },
    { value: "SE", label: "46" },
    { value: "CH", label: "41" },
    { value: "SY", label: "963" },
    { value: "TW", label: "886" },
    { value: "TJ", label: "7" },
    { value: "TZ", label: "255" },
    { value: "TH", label: "66" },
    { value: "TL", label: "256" },
    { value: "TG", label: "228" },
    { value: "TO", label: "676" },
    { value: "TT", label: "1-868" },
    { value: "TN", label: "216" },
    { value: "TR", label: "90" },
    { value: "TM", label: "993" },
    { value: "TC", label: "1" },
    { value: "TV", label: "688" },
    { value: "UG", label: "256" },
    { value: "UA", label: "380" },
    { value: "AE", label: "971" },
    { value: "GB", label: "44" },
    { value: "US", label: "1" },
    { value: "UY", label: "598" },
    { value: "UZ", label: "998" },
    { value: "VU", label: "678" },
    { value: "VE", label: "58" },
    { value: "VN", label: "84" },
    { value: "VI", label: "1-809" },
    { value: "PS", label: "" },
    { value: "YE", label: "967" },
    { value: "ZM", label: "260" },
    { value: "ZW", label: "263" },
    { value: "YE", label: "967" },
    { value: "ZM", label: "260" },
    { value: "ZW", label: "263" },
];

defineds.COUNTRY = [
    { value: "KR", label: "Korea, Republic of" },
    { value: "AF", label: "Afghanistan" },
    { value: "AL", label: "Albania" },
    { value: "DZ", label: "Algeria" },
    { value: "AS", label: "American Samoa" },
    { value: "AD", label: "Andorra" },
    { value: "AO", label: "Angola" },
    { value: "AG", label: "Antigua and Barbuda" },
    { value: "AR", label: "Argentina" },
    { value: "AM", label: "Armenia" },
    { value: "AW", label: "Aruba" },
    { value: "AU", label: "Australia" },
    { value: "AT", label: "Austria" },
    { value: "AZ", label: "Azerbaijan" },
    { value: "BS", label: "Bahamas" },
    { value: "BH", label: "Bahrain" },
    { value: "BD", label: "Bangladesh" },
    { value: "BB", label: "Barbados" },
    { value: "BY", label: "Belarus" },
    { value: "BE", label: "Belgium" },
    { value: "BZ", label: "Belize" },
    { value: "BJ", label: "Benin" },
    { value: "BM", label: "Bermuda" },
    { value: "BT", label: "Bhutan" },
    { value: "BO", label: "Bolivia" },
    { value: "BA", label: "Bosnia and Herzegovina" },
    { value: "BW", label: "Botswana" },
    { value: "BR", label: "Brazil" },
    { value: "BN", label: "Brunei Darussalam" },
    { value: "BG", label: "Bulgaria" },
    { value: "BF", label: "Burkina Faso" },
    { value: "BI", label: "Burundi" },
    { value: "KH", label: "Cambodia" },
    { value: "CM", label: "Cameroon" },
    { value: "CA", label: "Canada" },
    { value: "CV", label: "Cape Verde" },
    { value: "KY", label: "Cayman Islands" },
    { value: "CF", label: "Central African Republic" },
    { value: "TD", label: "Chad" },
    { value: "GG", label: "Channel Islands" },
    { value: "CL", label: "Chile" },
    { value: "CN", label: "China" },
    { value: "CO", label: "Colombia" },
    { value: "KM", label: "Comoros" },
    { value: "CG", label: "Congo" },
    { value: "CD", label: "Congo, The Democratic Republic of the" },
    { value: "CR", label: "Costa Rica" },
    { value: "CI", label: "Cote D'Ivoire" },
    { value: "HR", label: "Croatia" },
    { value: "CU", label: "Cuba" },
    { value: "CW", label: "Curaçao" },
    { value: "CY", label: "Cyprus" },
    { value: "CZ", label: "Czech Republic" },
    { value: "DK", label: "Denmark" },
    { value: "DJ", label: "Djibouti" },
    { value: "DM", label: "Dominica" },
    { value: "DO", label: "Dominican Republic" },
    { value: "EC", label: "Ecuador" },
    { value: "EG", label: "Egypt" },
    { value: "SV", label: "El Salvador" },
    { value: "GQ", label: "Equatorial Guinea" },
    { value: "ER", label: "Eritrea" },
    { value: "EE", label: "Estonia" },
    { value: "ET", label: "Ethiopia" },
    { value: "FO", label: "Faroe Islands" },
    { value: "FJ", label: "Fiji" },
    { value: "FI", label: "Finland" },
    { value: "FR", label: "France" },
    { value: "PF", label: "French Polynesia" },
    { value: "GA", label: "Gabon" },
    { value: "GM", label: "Gambia" },
    { value: "GE", label: "Georgia" },
    { value: "DE", label: "Germany" },
    { value: "GH", label: "Ghana" },
    { value: "GI", label: "Gibraltar" },
    { value: "GR", label: "Greece" },
    { value: "GL", label: "Greenland" },
    { value: "GD", label: "Grenada" },
    { value: "GU", label: "Guam" },
    { value: "GT", label: "Guatemala" },
    { value: "GN", label: "Guinea" },
    { value: "GW", label: "Guinea-Bissau" },
    { value: "GY", label: "Guyana" },
    { value: "HT", label: "Haiti" },
    { value: "HN", label: "Honduras" },
    { value: "HK", label: "Hong Kong" },
    { value: "HU", label: "Hungary" },
    { value: "IS", label: "Iceland" },
    { value: "IN", label: "India" },
    { value: "ID", label: "Indonesia" },
    { value: "IR", label: "Iran, Islamic Republic of" },
    { value: "IQ", label: "Iraq" },
    { value: "IE", label: "Ireland" },
    { value: "IM", label: "Isle of Man" },
    { value: "IL", label: "Israel" },
    { value: "IT", label: "Italy" },
    { value: "JM", label: "Jamaica" },
    { value: "JP", label: "Japan" },
    { value: "JO", label: "Jordan" },
    { value: "KZ", label: "Kazakhstan" },
    { value: "KE", label: "Kenya" },
    { value: "KI", label: "Kiribati" },
    { value: "KS", label: "Kosovo" },
    { value: "KW", label: "Kuwait" },
    { value: "KG", label: "Kyrgyzstan" },
    { value: "LA", label: "Lao People's Democratic Republic" },
    { value: "LV", label: "Latvia" },
    { value: "LB", label: "Lebanon" },
    { value: "LS", label: "Lesotho" },
    { value: "LR", label: "Liberia" },
    { value: "LY", label: "Libyan Arab Jamahiriya" },
    { value: "LI", label: "Liechtenstein" },
    { value: "LT", label: "Lithuania" },
    { value: "LU", label: "Luxembourg" },
    { value: "MO", label: "Macau" },
    { value: "MK", label: "Macedonia" },
    { value: "MG", label: "Madagascar" },
    { value: "MW", label: "Malawi" },
    { value: "MY", label: "Malaysia" },
    { value: "MV", label: "Maldives" },
    { value: "ML", label: "Mali" },
    { value: "MT", label: "Malta" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MR", label: "Mauritania" },
    { value: "MU", label: "Mauritius" },
    { value: "YT", label: "Mayotte" },
    { value: "MX", label: "Mexico" },
    { value: "FM", label: "Micronesia, Federated States of" },
    { value: "MD", label: "Moldova, Republic of" },
    { value: "MC", label: "Monaco" },
    { value: "MN", label: "Mongolia" },
    { value: "ME", label: "Montenegro" },
    { value: "MA", label: "Morocco" },
    { value: "MZ", label: "Mozambique" },
    { value: "MM", label: "Myanmar" },
    { value: "NA", label: "Namibia" },
    { value: "NP", label: "Nepal" },
    { value: "NL", label: "Netherlands" },
    { value: "NC", label: "New Caledonia" },
    { value: "NZ", label: "New Zealand" },
    { value: "NI", label: "Nicaragua" },
    { value: "NE", label: "Niger" },
    { value: "NG", label: "Nigeria" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "NO", label: "Norway" },
    { value: "OM", label: "Oman" },
    { value: "PK", label: "Pakistan" },
    { value: "PW", label: "Palau" },
    { value: "PA", label: "Panama" },
    { value: "PG", label: "Papua New Guinea" },
    { value: "PY", label: "Paraguay" },
    { value: "PE", label: "Peru" },
    { value: "PH", label: "Philippines" },
    { value: "PL", label: "Poland" },
    { value: "PT", label: "Portugal" },
    { value: "PR", label: "Puerto Rico" },
    { value: "QA", label: "Qatar" },
    { value: "RO", label: "Romania" },
    { value: "RU", label: "Russian Federation" },
    { value: "RW", label: "Rwanda" },
    { value: "WS", label: "Samoa" },
    { value: "SM", label: "San Marino" },
    { value: "ST", label: "Sao Tome and Principe" },
    { value: "SA", label: "Saudi Arabia" },
    { value: "SN", label: "Senegal" },
    { value: "RS", label: "Serbia" },
    { value: "SC", label: "Seychelles" },
    { value: "SL", label: "Sierra Leone" },
    { value: "SG", label: "Singapore" },
    { value: "SX", label: "Sint Maarten (Dutch part)" },
    { value: "SK", label: "Slovakia" },
    { value: "SI", label: "Slovenia" },
    { value: "SB", label: "Solomon Islands" },
    { value: "SO", label: "Somalia" },
    { value: "ZA", label: "South Africa" },
    { value: "SS", label: "South Sudan" },
    { value: "ES", label: "Spain" },
    { value: "LK", label: "Sri Lanka" },
    { value: "KN", label: "St. Kitts and Nevis" },
    { value: "LC", label: "St. Lucia" },
    { value: "MF", label: "St. Martin (French part)" },
    { value: "VC", label: "St. Vincent and the Grenadines" },
    { value: "SD", label: "Sudan" },
    { value: "SR", label: "Suriname" },
    { value: "SZ", label: "Swaziland" },
    { value: "SE", label: "Sweden" },
    { value: "CH", label: "Switzerland" },
    { value: "SY", label: "Syrian Arab Republic" },
    { value: "TW", label: "Taiwan" },
    { value: "TJ", label: "Tajikistan" },
    { value: "TZ", label: "Tanzania, United Republic of" },
    { value: "TH", label: "Thailand" },
    { value: "TL", label: "Timor-Leste" },
    { value: "TG", label: "Togo" },
    { value: "TO", label: "Tonga" },
    { value: "TT", label: "Trinidad and Tobago" },
    { value: "TN", label: "Tunisia" },
    { value: "TR", label: "Türkiye" },
    { value: "TM", label: "Turkmenistan" },
    { value: "TC", label: "Turks and Caicos Islands" },
    { value: "TV", label: "Tuvalu" },
    { value: "UG", label: "Uganda" },
    { value: "UA", label: "Ukraine" },
    { value: "AE", label: "United Arab Emirates" },
    { value: "GB", label: "United Kingdom" },
    { value: "US", label: "United States" },
    { value: "UY", label: "Uruguay" },
    { value: "UZ", label: "Uzbekistan" },
    { value: "VU", label: "Vanuatu" },
    { value: "VE", label: "Venezuela" },
    { value: "VN", label: "Vietnam" },
    { value: "VI", label: "Virgin Islands, U.S." },
    { value: "PS", label: "West Bank and Gaza" },
    { value: "YE", label: "Yemen" },
    { value: "ZM", label: "Zambia" },
    { value: "ZW", label: "Zimbabwe" },
];

defineds.AUTHOR_TITLE = [
    { value: "Prof.", label: "Prof." },
    { value: "Dr.", label: "Dr." },
    { value: "Mr.", label: "Mr." },
    { value: "Ms.", label: "Ms." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Other", label: "Other" },
];

defineds.PRESENT_TYPE = [
    { value: "Oral", label: "Oral" },
    { value: "Poster", label: "Poster" },
    { value: "E-poster", label: "E-Poster" },
];

defineds.PAYMENT_STATUS = [
    { value: "Y", label: "Completed" },
    { value: "N", label: "Payment needed" },
];

defineds.ABSTRACT_STATUS = [
    { value: "W", label: "In progress" },
    { value: "Y", label: "Complete" },
    { value: "N", label: "Withdrwal" },
];

defineds.FINAL_STATUS = [
    { value: "Y", label: "Accepted" },
    { value: "R", label: "Rejected" },
];

export default defineds;
